import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "sectionsTable", "mapsTable", "pagesTable",
    "sectionSelect", "mapSelect", "pageSelect"
  ]

  connect() {
    $(this.element).find('.sortable').sortable({
      axis: 'y',
      handle: '.sortable-handle',
      update: () => this.setPositions()
    })
  }

  openModal(event) {
    const container = event.currentTarget.closest('.section-group-data')
    const dataType = container.dataset.type
    const select = this.selectForType(dataType)
    if (!select) return

    container.querySelectorAll('.data-id').forEach(el => {
      this.#setOptionDisabled(select, el.value, true)
    })

    const modal = container.querySelector('.modal')
    $(modal).one('shown.bs.modal', () => {
      if (select.tomselect) select.tomselect.focus()
      else select.focus()
    })
  }

  deleteData(event) {
    event.preventDefault()
    const tr = event.currentTarget.closest('tr')
    const container = event.currentTarget.closest('.section-group-data')
    const dataType = container.dataset.type
    const dataId = tr.querySelector('.data-id')?.value
    const destroyBtn = tr.querySelector('.destroy')
    const select = this.selectForType(dataType)

    if (select && dataId) {
      this.#setOptionDisabled(select, dataId, false)
    }

    if (destroyBtn) {
      destroyBtn.value = 'true'
      tr.querySelector('.position')?.remove()
      tr.querySelector('.data-id')?.remove()
      tr.style.display = 'none'
    } else {
      tr.remove()
    }

    this.setPositions()
  }

  addData(event) {
    event.preventDefault()

    const container = event.currentTarget.closest('.section-group-data')
    const dataType = container.dataset.type

    let elt, table
    if (dataType === 'Node') {
      elt = this.sectionSelectTarget
      table = this.sectionsTableTarget
    } else if (dataType === 'Page') {
      elt = this.pageSelectTarget
      table = this.pagesTableTarget
    } else if (dataType === 'Map') {
      elt = this.mapSelectTarget
      table = this.mapsTableTarget
    }

    if (!elt) return

    const selectedValues = elt.tomselect
      ? [].concat(elt.tomselect.getValue()).filter(Boolean)
      : Array.from(elt.selectedOptions).map(o => o.value)

    if (selectedValues.length === 0) return

    selectedValues.forEach(value => {
      const opt = elt.tomselect ? elt.tomselect.options[value] : elt.querySelector(`option[value="${value}"]`)
      const label = elt.tomselect ? (opt?.text || value) : (opt?.text || value)
      const itemDataType = dataType === 'Map'
        ? (elt.tomselect ? opt?.mapType : opt?.dataset?.mapType) || dataType
        : dataType

      const id = this.sectionsTableTarget.children.length +
                 this.pagesTableTarget.children.length +
                 this.mapsTableTarget.children.length + 1
      const position = container.querySelectorAll('.position').length + 1

      const tr = document.createElement('tr')
      tr.innerHTML =
        '<td class="sortable-handle ui-sortable-handle"><i class="glyphicon glyphicon-sort"></i></td>' +
        `<td>${label}</td>` +
        '<td align="right" class="options">' +
          '<a class="delete-data" href="#" data-action="click->section-group#deleteData">' +
            '<i title="" data-toggle="tooltip" data-placement="top" class="glyphicon glyphicon-trash" data-original-title="Delete"></i>' +
          '</a>' +
        '</td>' +
        `<input type="hidden" class="data-id" name="section_group[section_group_data_attributes][${id}][data_id]" value="${value}">` +
        `<input type="hidden" class="position" name="section_group[section_group_data_attributes][${id}][position]" value="${position}">` +
        `<input type="hidden" class="data-type" name="section_group[section_group_data_attributes][${id}][data_type]" value="${itemDataType}">`

      table.appendChild(tr)
      $(tr).find('[data-toggle="tooltip"]').tooltip()
      this.#setOptionDisabled(elt, value, true)
    })

    elt.tomselect?.clear()
    $(event.currentTarget.closest('.modal')).modal('hide')
  }

  submitForm(event) {
    event.target.closest("form").requestSubmit()
  }

  // private

  #setOptionDisabled(select, value, disabled) {
    if (select.tomselect) {
      const ts = select.tomselect
      const opt = ts.options[value]
      if (opt) {
        ts.updateOption(value, { ...opt, disabled })
        // updateOption re-renders the option but may not update data-selectable;
        // patch the rendered element directly as well
        const el = ts.getOption(value)
        if (el) {
          el.classList.toggle('disabled', disabled)
          if (disabled) el.removeAttribute('data-selectable')
          else el.setAttribute('data-selectable', '')
        }
      }
    } else {
      const option = select.querySelector(`option[value="${value}"]`)
      if (option) option.disabled = disabled
    }
  }

  selectForType(dataType) {
    if (dataType === 'Node') return this.sectionSelectTarget
    if (dataType === 'Page') return this.pageSelectTarget
    if (dataType === 'Map') return this.mapSelectTarget
    return null
  }

  setPositions() {
    this.element.querySelectorAll('.position').forEach((el, i) => {
      el.value = i + 1
    })
  }
}
